import { z } from 'zod';

export const updateKeyDetailsSchema = z.object({
  division: z.string().nonempty(),
  department: z.string().nonempty(),
  category: z.string().nonempty(),
  class: z.string().nonempty(),
  style_number: z.string().nonempty(),
  jr_cost: z.number().min(1),
  plus_cost: z.number().min(1).nullable(),
  fashionnova_exclusive: z.boolean(),
  fit_sample: z.boolean(),
  lead_time_in_weeks: z.number().min(1),
  country_of_origin: z.string().nonempty(),
  front_content_type: z.string().optional().nullable(),
  swatch_content_type: z.string().optional().nullable(),
});

export type UpdateKeyDetailsInputs = z.infer<typeof updateKeyDetailsSchema>;
